import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import { Header, Page } from 'components'
import { useDivisaoService } from 'hooks/useDivisaoService'
import { useAuth } from 'hooks/useAuth'
import constants from 'utils/constants'
import useRouter from 'utils/useRouter'

import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const Divisoes = (props) => {
  const { route } = props
  const router = useRouter()
  const divisaoService = useDivisaoService()
  const classes = useStyles()
  const idRegional = useSelector((state) => state.idsState.idRegional)
  const divisoes = useSelector((state) => state.divisoes.divisoes)
  const { permissoesUsuario, verificarPermissao } = useAuth()

  useEffect(() => {

    if (permissoesUsuario?.length) {
      if(!verificarPermissao([constants.PERMISSOES.ADMINISTRAR_SISTEMA])) {
        router.history.push(`/`)
      }
    }
  }, [permissoesUsuario])

  useEffect(() => {
    if (route.global) {
      if (idRegional) {
        divisaoService.listarDivisoesDeRegionalGlobal(idRegional)
      }
    } else {
      divisaoService.listarDivisoesDeRegionalGlobal(route.idRegional)
    }

  }, [idRegional, route.idRegional])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header
        titulo={`${route.secao}`}
        overline={route.secao}
        textoBotao="Cadastrar novo"
        linkBotao={`${route.path}/cadastrar`}
        idPai={route.idRegional}
      />
      {divisoes && <Results className={classes.results} dados={divisoes} />}
    </Page>
  )
}
